// src/components/PWAInstallPrompt.js
import React, { useState, useEffect } from 'react';

function PWAInstallPrompt() {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showPrompt, setShowPrompt] = useState(false);
  const [showManualPrompt, setShowManualPrompt] = useState(false);

  useEffect(() => {
    console.log('[PWA Debug] Iniciando PWA Install Prompt...');
    
    const today = new Date().toDateString();
    const lastShown = localStorage.getItem('pwa-prompt-last-shown');
    const dismissed = localStorage.getItem('pwa-prompt-dismissed');
    
    if (lastShown === today || dismissed === 'true') {
      return;
    }

    const isStandalone = window.matchMedia('(display-mode: standalone)').matches ||
                         window.navigator.standalone ||
                         document.referrer.includes('android-app://');

    if (isStandalone) {
      return;
    }

    const supportsBeforeInstallPrompt = 'onbeforeinstallprompt' in window;

    const handleBeforeInstallPrompt = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      
      setTimeout(() => {
        setShowPrompt(true);
        localStorage.setItem('pwa-prompt-last-shown', today);
      }, 90000);
    };

    window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);

    const fallbackTimer = setTimeout(() => {
      if (!deferredPrompt && !supportsBeforeInstallPrompt) {
        setShowManualPrompt(true);
        localStorage.setItem('pwa-prompt-last-shown', today);
      }
    }, 120000);

    return () => {
      window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
      clearTimeout(fallbackTimer);
    };
  }, [deferredPrompt]);

  const handleInstallClick = async () => {
    if (deferredPrompt) {
      deferredPrompt.prompt();
      await deferredPrompt.userChoice;
      setDeferredPrompt(null);
      setShowPrompt(false);
    } else {
      setShowManualPrompt(false);
      setShowPrompt(false);
    }
  };

  const handleDismiss = () => {
    setShowPrompt(false);
    setShowManualPrompt(false);
  };

  const handleNeverShow = () => {
    localStorage.setItem('pwa-prompt-dismissed', 'true');
    setShowPrompt(false);
    setShowManualPrompt(false);
  };

  if (!showPrompt && !showManualPrompt) return null;

  const isManualPrompt = showManualPrompt && !showPrompt;

  return (
    <div className="pwa-install-overlay">
      <div className="pwa-install-prompt">
        <div className="pwa-prompt-header">
          <span className="pwa-icon">📱</span>
          <h3>¡Instala nuestra App!</h3>
          <button className="pwa-close-btn" onClick={handleDismiss}>×</button>
        </div>
        
        <div className="pwa-prompt-body">
          <p>
            <strong>Pedidos de Oración</strong> funciona mejor como app instalada:
          </p>
          <ul className="pwa-benefits">
            <li>Acceso más rápido desde tu pantalla de inicio</li>
            <li>Funciona offline para que puedas orar siempre</li>
            <li>Experiencia nativa como app móvil</li>
            <li>Carga más rápida y fluida</li>
          </ul>
          
          {isManualPrompt && (
            <div className="pwa-manual-instructions">
              <p><strong>Para instalar en iOS/Safari:</strong></p>
              <ol>
                <li>Toca el botón "Compartir"</li>
                <li>Selecciona "Añadir a pantalla de inicio"</li>
                <li>Confirma tocando "Añadir"</li>
              </ol>
            </div>
          )}
        </div>

        <div className="pwa-prompt-actions">
          {!isManualPrompt ? (
            <button className="pwa-install-btn" onClick={handleInstallClick}>
              Instalar App
            </button>
          ) : (
            <button className="pwa-install-btn" onClick={handleDismiss}>
              Entendido
            </button>
          )}
          
          <button className="pwa-later-btn" onClick={handleDismiss}>
            Ahora no
          </button>
          <button className="pwa-never-btn" onClick={handleNeverShow}>
            No volver a mostrar
          </button>
        </div>
      </div>
    </div>
  );
}

export default PWAInstallPrompt;